import { css } from '@emotion/css';
import { Switch } from '@grafana/ui';
import React__default from 'react';

const EditorSwitch = (props) => {
  const styles = getStyles();
  return /* @__PURE__ */ React__default.createElement("div", { className: styles.switch }, /* @__PURE__ */ React__default.createElement(Switch, { ...props }));
};
const getStyles = () => {
  return {
    switch: css({
      display: "flex",
      alignItems: "center",
      minHeight: 30
    })
  };
};

export { EditorSwitch };
//# sourceMappingURL=EditorSwitch.js.map
